import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { Home } from './pages/Home';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { Disclaimer } from './pages/Disclaimer';
import { CookieBanner } from './components/ui/CookieBanner';
import { Toaster } from 'sonner';
import { initMetaPixel } from './utils/metaPixel';
import { useContentGuard } from './utils/useContentGuard';
export function App() {
  useContentGuard();
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <BrowserRouter data-id="element-0">
      <LanguageProvider data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/privacy" element={<Privacy data-id="element-6" />} data-id="element-5" />
          <Route path="/terms" element={<Terms data-id="element-8" />} data-id="element-7" />
          <Route path="/disclaimer" element={<Disclaimer data-id="element-10" />} data-id="element-9" />
        </Routes>
        <CookieBanner data-id="element-11" />
        <Toaster position="bottom-center" richColors data-id="element-12" />
        {/* Meta Pixel noscript fallback */}
        <noscript data-id="element-13">
          <img height="1" width="1" style={{
          display: 'none'
        }} src="https://www.facebook.com/tr?id=6810483222354785&ev=PageView&noscript=1" alt="" data-id="element-14" />
        </noscript>
      </LanguageProvider>
    </BrowserRouter>;
}